import React from "react";

import {
  Badge,
  Flex,
  FlexItem,
  Tooltip
} from "@patternfly/react-core";

import QualificationProgressChart from "./QualificationProgressChart";

const GroupProgress = ({
  groups,
  themeVersion
}) => {
  return (
    <Flex>
      {groups.map((group) => (
        <FlexItem
          key={group.group_symbol}
          style={{
            paddingBottom: "20px",
            textAlign: "center",
            marginTop: "20px"
          }}
        >
          <Tooltip content={<div>{group.group_name}</div>}>
            <Badge style={{ fontWeight: "bold" }}>
              {group.group_symbol}
            </Badge>
          </Tooltip>

          <br />
          <br />

          {Object.values(
            group.group_qualification_completed ?? {}
          ).map((data) => (
            <QualificationProgressChart
              key={data.uid}
              group={group}
              data={data}
              themeVersion={themeVersion}
            />
          ))}
        </FlexItem>
      ))}
    </Flex>
  );
};

export default GroupProgress;